import { createFileRoute } from '@tanstack/react-router'

import { InsuranceCertificateGeneratorRealEstateSalesAgentsPage } from '../../../../../components/pages/insurance-certificate-generator/insurance-certificate-generator-real-estate-sales-agents-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute(
  '/(customer)/_portal/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId',
)({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <InsuranceCertificateGeneratorRealEstateSalesAgentsPage />
    </PermissionChecker>
  ),
})
